import { Component, AfterViewInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { Base } from './../../../../../_models/Classes';
import { TableController } from './../../../../../_models/Classes/table-controller';

@Component({
    selector: 'app-money-list',
    templateUrl: './money-list.component.html',
    styleUrls: ['./money-list.component.scss']
})
export class MoneyListComponent extends TableController {
    currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    listData = [];
    total: number;
    helpers = new Base();
    @Input() endPoint = "";
    @Input() totalText = "";
    @Input() label = "dinero";
    @Input() newEntry = {
        link: 'javascript:void(0)',
        text: 'Nuevo Registro'
    };
    @Input() widgetClass = "m-portlet m-portlet--skin-dark m-portlet--bordered-semi";
    @Output() search = new EventEmitter();
    @Output() clear = new EventEmitter();
    @Output() deleteEl = new EventEmitter();
    tableMessages = {
        emptyMessage: 'No hay datos para mostrar',
    };
    searchString: string;
    elementToDelete: number;
    constructor(
        protected cp: CurrencyPipe
    ) { super(); }

    set list(data) {
        this.handleList(data);
    }

    private handleList(list) {
        this.total = 0.00;
        list.filter((money: any) => { this.total += parseFloat(money.amount); });
        this.listData = list;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/common/list/money-list.component.ts